import React, { useState, useEffect, useMemo } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useIdleTimer, workerTimers } from 'react-idle-timer';
import "./App.css";

import { Modal, Box, Typography, Container } from "@mui/material";

import Login from "./components/Login";
import Home from "./components/Home";
import Logout from "./components/Logout";
import NotFound from "./components/NotFound";
import PasswordRequest from "./components/PasswordRequest";
import PasswordReset from "./components/PasswordReset";
import PersonalReport from "./components/PersonalReport";
import PhysicianSummary from "./components/PhysicianSummary";
import AdminReport from "./components/AdminReport";
import HRA from "./components/HRA";
import HRA2 from "./components/HRA2";
import Profile from "./components/Profile";
import HealthShelf from './components/HealthShelf'
import SAML from './components/SAML'
import { logout } from "./actions/auth";
import { clearMessage } from "./actions/message";


import { history } from "./helpers/history";
import AdminCenterParticipants from "./components/AdminCenterParticipants";
import AdminCenterReports from "./components/AdminCenterReports";
import { fetchErrorMessages, selectErrorMessagesByKeyName } from "./reducers/reference_errormessages";
import { userKeepAlive, userLogout, authClear } from "./reducers/auth";
import AdminCenterGroups from "./components/AdminCenterGroups";
import HealthShelfArticle from "./components/HealthShelfArticle";
import HomeReRoute from "./components/HomeReRoute";
import { selectSettingForTypeKeyName } from "./reducers/reference_settings";
//import './print.css'
import PRPSPDFRoute from "./components/PRPSPDFRoute";



const App = () => {
    const [primaryColor, setPrimaryColor] = useState('#2196f3')
    const [secondaryColor, setSecondaryColor] = useState('#f50057')

    const theme = useMemo(() =>
        createTheme({
            palette: {
                primary: {
                    main: primaryColor
                },
                secondary: {
                    main: secondaryColor
                }
                , background: {
                    default: "rgb(243, 244, 249)"
                }
            }

        }), [primaryColor, secondaryColor]
    )

    const { viewInstance, settings } = useSelector(state => state.viewinstance)
    const themeColPrim = useSelector(state => selectSettingForTypeKeyName(state, { SettingTypeKeyName: "THEME COLOR" }))
    const themeColSec = useSelector(state => selectSettingForTypeKeyName(state, { SettingTypeKeyName: "THEME COLOR SECONDARY" }))
    const [getVI, setGetVI] = useState(true)
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation()

    const errormessageStatus = useSelector(state => state.errormessages.status)
    const errorMessages = useSelector(state => state.errormessages.entities)


    useEffect(() => {
        if (errormessageStatus === 'idle' && (searchParams.get("g") || localStorage.getItem('group'))) {
            dispatch(fetchErrorMessages({ groupGuid: searchParams.get("g") || localStorage.getItem('group'), languageID: -1 }))
        }

    }, [errormessageStatus, searchParams, dispatch])



    useEffect(() => {
        history.listen((location) => {
            dispatch(clearMessage()); // clear message when changing location
        });
    }, [dispatch]);

    useEffect(() => {
        if (settings && settings.OrganizationSettingValues && ((settings.OrganizationSettingValues['THEME COLOR'] && settings.OrganizationSettingValues['THEME COLOR'].length > 2) || (settings.OrganizationSettingValues[0].List['THEME COLOR'] && settings.OrganizationSettingValues[0].List['THEME COLOR'].length > 2))) {
            let themeColor = settings.OrganizationSettingValues['THEME COLOR'] ? settings.OrganizationSettingValues['THEME COLOR'] : settings.OrganizationSettingValues[0].List['THEME COLOR']
            setPrimaryColor(themeColor.charAt(0) === "#" ? themeColor : ("#" + themeColor))

        }
        if (themeColPrim && themeColPrim != primaryColor) {
            setPrimaryColor(themeColPrim.charAt(0) === "#" ? themeColPrim : ("#" + themeColPrim))
        }
        if (themeColSec && themeColSec != secondaryColor) {
            setSecondaryColor(themeColSec.charAt(0) === "#" ? themeColSec : ("#" + themeColSec))
        }
    }, [settings, themeColPrim, themeColSec])





    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {/* THIS IS THE CORRECTED PART */}
            <Container sx={{
                '@media print': {
                    minWidth: '100%',
                    maxWidth: '100%',
                    padding: 0,
                    margin: 0,
                },
            }}>
                <Routes>
                    <Route path="/home" element={<HomeReRoute />} />
                    <Route path="/logout" element={<Logout />} />
                    <Route path="/pwreset" element={<PasswordReset />} />
                    <Route path="/request" element={<PasswordRequest />} />
                    <Route path="/personalreport" element={<PersonalReport />} />
                    <Route path="/physiciansummary" element={<PhysicianSummary />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/adminreport" element={<AdminReport />} />
                    <Route path="/prpspdfroute" element={<PRPSPDFRoute />} />
                    <Route path="/admincenterreports" element={<AdminCenterReports />} />
                    <Route path="/prpspdfroute" element={<PRPSPDFRoute />} />
                    <Route path="/groupmanagement" element={<AdminCenterGroups />} />
                    <Route path="/participantmanagement" element={<AdminCenterParticipants />} />
                    <Route path="/healthshelfarticle" element={<HealthShelfArticle />} />
                    <Route path="/healthshelf" element={<HealthShelf />} />
                    <Route path="/hra" element={<HRA2 />} />
                    <Route path="/saml" element={<SAML />} />
                    <Route path="/" element={Login} />
                    <Route path="*" element={<Login />} />
                </Routes>
            </Container>
        </ThemeProvider>
    );
};

export default App;